import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Menu } from 'lucide-react';

const roleBadgeColors = {
  baskan: 'bg-gs-red text-white',
  yonetici: 'bg-gs-yellow text-gs-dark',
  uye: 'bg-gray-100 text-gray-700',
};

const roleLabels = {
  baskan: 'Başkan',
  yonetici: 'Yönetici',
  uye: 'Üye',
};

export default function Header({ title, onMenuToggle }) {
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-30 bg-white border-b border-gray-200 px-4 sm:px-6 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            onClick={onMenuToggle}
            className="lg:hidden p-2 min-w-[44px] min-h-[44px] flex items-center justify-center rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100"
          >
            <Menu size={22} />
          </button>
          <h2 className="text-lg sm:text-xl font-semibold text-gray-900">
            {title || 'Dashboard'}
          </h2>
        </div>

        <div className="flex items-center gap-3">
          <span className="hidden sm:inline text-sm text-gray-600">
            {user?.ad} {user?.soyad}
          </span>
          <span
            className={`inline-flex items-center px-2 sm:px-2.5 py-0.5 rounded-full text-[10px] sm:text-xs font-medium ${
              roleBadgeColors[user?.role] || roleBadgeColors.uye
            }`}
          >
            {roleLabels[user?.role] || user?.role}
          </span>
        </div>
      </div>
    </header>
  );
}
